import { memo } from "react";
import PropTypes from "prop-types";
import AmountContainer from "app/pages/.shared/AmountContainer";
import { FormattedMessage } from "react-intl";
import InfoPopover from "app/components/ui/InfoPopover/InfoPopover";
import "./TotalCreditBanner.scss";
import { MoneyBagFilledIcon } from "app/icons/finance";

const TotalCreditBanner = ({ totalCredit }) => {
	if (!totalCredit) {
		return false;
	}
	return (
		<div className="total-credit-banner" data-testid="total-credit-banner">
			<div className="total-credit-banner__content">
				<MoneyBagFilledIcon className="total-credit-banner__icon" />
				<FormattedMessage
					id="mycoupons.credit.banner.text"
					values={{
						amount: <AmountContainer amount={totalCredit} />,
					}}
					tagName="div"
				/>
			</div>
			<InfoPopover
				iconSize={15}
				iconStyle={{ marginLeft: "5px" }}
				iconClassName="total-credit-banner__cgu-icon"
				dataTestId="total-credit-banner-cgu-icon"
			>
				<div className="total-credit-banner__cgu" data-testid="total-credit-banner-cgu">
					<div className="total-credit-banner__cgu-description">
						<FormattedMessage id="mycoupons.credit.banner.info.description" />
					</div>
				</div>
			</InfoPopover>
		</div>
	);
};

TotalCreditBanner.propTypes = {
	totalCredit: PropTypes.any,
};

export default memo(TotalCreditBanner);
